
const materials = [
    {
      id: 'CRS11GA0120',
      name: 'CRS 11GA 0.120'
    },
    {
      id: 'CRS14GA0075',
      name: 'CRS 14GA 0.075'
    },
    {
      id: 'CRS16GA006',
      name: 'CRS 16GA 0.06'
    },
    {
      id: 'HRS1/40250',
      name: 'HRS 1/4 0.250'
    },
    {
      id: 'HRS10GA0135',
      name: 'HRS 10GA 0.135'
    },
    {
      id: 'HRS11GA0120',
      name: 'HRS 11GA 0.120'
    }
    ,
    {
      id: 'HRS12GA0104',
      name: 'HRS 12GA 0.104'
    },
    {
      id: 'HRS3/80375',
      name: 'HRS 3/8 0.375'
    },
    {
      id: 'HRS3/160188',
      name: 'HRS 3/16 0.188'
    }
    ,
    {
      id: 'HRS3/40075',
      name: 'HRS 3/4 0.075'
    },
    {
      id: 'SC20GA0040',
      name: 'SC 20GA 0.040'
    },
    {
      id: 'SS2000383162B',
      name: 'SS 20GA 0.038-316-2B'
    },
    {
      id: 'SS180050316L2B',
      name: 'SS 18GA 0.050-316L-2B'
    },
    {
      id: 'EXPANDEDMETAL',
      name: 'EXPANDED METAL'
    }
  ];
  
  export default materials;